<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="selectTypeNames.static_data_Location"
    :cache="false"
    filterable
    :default-value="defaultValue"
    :static-options="options"
    :placeholder="placeholder||undefined"
    @parentCallBack="p=>{$emit('change',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLocationList } from '@/api/location'
// 城市列表
let locationList = null
// 城市请求回调数组（针对请求正在加载中的情况）
let locationCallback = null
// 当前（组件）被使用次数
let usedCount = 0
// 当前（组件）实例数量
let instanceCount = 0

export default {
  name: 'CargoLocationSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      options: []
    }
  },
  created() {
    usedCount += 1
    instanceCount += 1
    if (locationList) {
      this.options = locationList
      return
    }
    if (locationCallback) { // 正在加载中
      locationCallback.push(() => {
        this.options = locationList
      })
    } else { // 加载数据，同时初始化回调数组
      locationCallback = [() => {
        this.options = locationList
      }]
      getLocationList({ pageSize: 10000 }).then(res => {
        locationList = res.data.list
        for (const func of locationCallback) {
          func()
        }
        locationCallback = null
      }).catch(() => {
        locationCallback = null
      })
    }
  },
  destroyed() {
    instanceCount -= 1
    if (instanceCount <= 0) {
      setTimeout(currentUsedCount => {
        if (currentUsedCount === usedCount) {
          locationList = null
        }
      }, 5 * 60 * 1000, usedCount)
    }
  }
}
</script>

<style>
</style>
